import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SwitchListItem from '../../../../../../list-items/SwitchListItem/SwitchListItem';

const WaveLayerCutoutListItem = memo(({ index, cutout, updateWaveLayerCustomOptions }) => {
    const handleChange = useCallback(
        (_, value) => updateWaveLayerCustomOptions(index, "cutout", value),
        [index]
    );

    return (
        <SwitchListItem
            checked={cutout !== undefined ? cutout : false}
            onChange={handleChange}
            text="Transparent"
            toolTip="Turns this layer into a hole that reveals the background. It only cuts the layers behind it, so layers in front stay visible."
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { cutout } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { cutout };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerCutoutListItem);
